import axios from "axios";
import { appConstants } from "./appConstants";

async function requestAbr(path, payload) {
  try {
    const { data } = await axios.post(
      `${appConstants.baseURL}abr/${path}`,
      payload,
      {
        headers: path.startsWith("signup/")
          ? {}
          : { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
        timeout: 15000,
      }
    );
    if (!data.Result_Status) throw new Error(data.Result_Message);
    return data.Result_Output;
  } catch (error) {
    throw new Error(
      error.response?.data?.Result_Message ||
        error.message ||
        "ABR lookup failed."
    );
  }
}

export const searchAbrCompanies = (companyName) =>
  requestAbr("search", { companyName });
export const verifyAbrAbn = (abn) => requestAbr("verify", { abn });

// Signup does not yet have a login token; these endpoints are rate limited.
export const searchSignupAbrCompanies = (companyName) =>
  requestAbr("signup/search", { companyName });
export const verifySignupAbrAbn = (abn) => requestAbr("signup/verify", { abn });
